import { render, staticRenderFns } from "./BannerVideoPlayer.vue?vue&type=template&id=12d9b783&scoped=true"
import script from "./BannerVideoPlayer.vue?vue&type=script&lang=js"
export * from "./BannerVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./BannerVideoPlayer.vue?vue&type=style&index=0&id=12d9b783&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d9b783",
  null
  
)

export default component.exports